/**
 * Enum de condição de autodiagnósticos.
 */
// eslint-disable-next-line import/prefer-default-export
export const moduleSelfDiagnosisStatus = {
  WITH_SELF_DIAGNOSES_ACTIVATED: 'with-self-diagnoses-activated',
  WITHOUT_SELF_DIAGNOSES_ACTIVATED: 'without-self-diagnoses-activated',
  UNDETERMINED: 'undetermined',
};
